import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import CalendarEntryInfoButton from "./CalendarEntryInfoButton";
import {
  parseCentralDateTime,
  formatTimeInZone,
  getLocalTimezone,
  getDayOfWeekInZone,
  getMonthInZone,
  getDayInZone,
} from "../utils/calendarTimezone";
import "./CalendarEntry.scss";

const CENTRAL_TIMEZONE = "America/Chicago";

const CalendarEntry = ({ classData }) => {
  const { start_date, start_time, end_time, title } = classData;

  // Parse as Central Time - handles DST correctly regardless of user's timezone
  const startDateTime = parseCentralDateTime(start_date, start_time);
  const endDateTime = parseCentralDateTime(start_date, end_time);

  const localTimeZone = getLocalTimezone();

  // Format times for display
  const startTimeCentralFormatted = formatTimeInZone(startDateTime, CENTRAL_TIMEZONE);
  const endTimeCentralFormatted = formatTimeInZone(endDateTime, CENTRAL_TIMEZONE);
  const startTimeLocalFormatted = formatTimeInZone(startDateTime, localTimeZone);
  const endTimeLocalFormatted = formatTimeInZone(endDateTime, localTimeZone);

  // Date and day formatting for Central Time
  const dayOfWeek = getDayOfWeekInZone(startDateTime, CENTRAL_TIMEZONE);
  const month = getMonthInZone(startDateTime, CENTRAL_TIMEZONE);
  const day = getDayInZone(startDateTime, CENTRAL_TIMEZONE);

  return (
    <div className="calendar-entry-container">
      <div className="class-date">
        <p className="dow">{dayOfWeek}</p>
        <p className="cal-month">{month}</p>
        <p className="cal-day">{day}</p>
      </div>
      <div className="class-info">
        <p className="class-name">{title}</p>
        <div className="class-times">
          <p className="class-time">
            <FontAwesomeIcon className="cal-icon" icon={faClock} />{" "}
            {startTimeCentralFormatted} - {endTimeCentralFormatted} <span className="timezone">(Central Time)</span>
          </p>
          <p className="class-time">
            <FontAwesomeIcon className="cal-icon" icon={faClock} />{" "}
            {startTimeLocalFormatted} - {endTimeLocalFormatted} <span className="timezone">(Your Time)</span>
          </p>
        </div>
      </div>
      <CalendarEntryInfoButton 
        classData={classData} 
        startTimeCentralFormatted={startTimeCentralFormatted}
        endTimeCentralFormatted={endTimeCentralFormatted}
        startTimeLocalFormatted={startTimeLocalFormatted}
        endTimeLocalFormatted={endTimeLocalFormatted}
      />
    </div>
  );
};

export default CalendarEntry;
